import { c as _c } from "react/compiler-runtime";
import { type IconButtonProps, headlessIconButtonProps } from 'design-system/server';
import Link, { type DynamicLinkProps } from '../Link/Link';
type ButtonLinkProps = Omit<IconButtonProps<'a'>, 'as' | 'href'> & Omit<DynamicLinkProps, 'passHref' | 'legacyBehavior'>;
function ButtonLink(t0) {
  const $ = _c(14);
  let linkProps;
  let t1;
  if ($[0] !== t0) {
    const {
      href,
      scroll,
      as,
      replace,
      shallow,
      prefetch,
      locale,
      ...props
    } = t0;
    let t2;
    if ($[3] !== as || $[4] !== href || $[5] !== locale || $[6] !== prefetch || $[7] !== replace || $[8] !== scroll || $[9] !== shallow) {
      t2 = {
        href,
        scroll,
        as,
        replace,
        shallow,
        prefetch,
        locale
      };
      $[3] = as;
      $[4] = href;
      $[5] = locale;
      $[6] = prefetch;
      $[7] = replace;
      $[8] = scroll;
      $[9] = shallow;
      $[10] = t2;
    } else {
      t2 = $[10];
    }
    linkProps = t2;
    t1 = headlessIconButtonProps({
      ...props,
      as: "a"
    } as IconButtonProps<'a'>);
    $[0] = t0;
    $[1] = linkProps;
    $[2] = t1;
  } else {
    linkProps = $[1];
    t1 = $[2];
  }
  const props_ = t1;
  let t2;
  if ($[11] !== linkProps || $[12] !== props_) {
    t2 = <Link {...linkProps} {...props_} />;
    $[11] = linkProps;
    $[12] = props_;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  return t2;
}
export default ButtonLink;